import { useTranslations } from "contexts/LocalizationContext";
import config from "config/config";
import type { LogInButtonProps } from "./types";
import { NavButton } from "./NavButton";

const LOGIN_BUTTON_EVENT = { event: "login_click", placement: "top_menu" } as const;
const LOGIN_BUTTON_EVENT_UA = ["clicked", "TopMenu", "Login"] as const;

export const LogInButton = ({ labelKey = "button_login", ...props }: LogInButtonProps) => {
  const translations = useTranslations();

  return (
    <NavButton
      href={`${config.webappUrl}/claims-and-flights`}
      title={translations(labelKey)}
      gaEvent={LOGIN_BUTTON_EVENT}
      uaEvent={LOGIN_BUTTON_EVENT_UA}
      dataTestId="top-navbar-view-status-button"
      {...props}
    />
  );
};
